import type { ActivityEventProps } from "./activity-event.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { Tag } from "@/ui/tag";

import {
  getActivityEventColor,
  getActivityEventLabelKey,
} from "./activity-event.helper";

export const ActivityEvent = ({ activity, ...props }: ActivityEventProps) => {
  const { t } = useTranslation();

  const color = getActivityEventColor(activity);
  const labelKey = getActivityEventLabelKey(activity);

  return (
    <Tag color={color} {...props}>
      <Typography.Text>{t(`activity:staticState:${labelKey}`)}</Typography.Text>
    </Tag>
  );
};
